import { createSelector } from 'reselect';

export const getWishes = state => state.wishes;

export const getWishesFilters = createSelector(
  getWishes,
  wishes => wishes.filters
);

export const getWishesFiltersChecked = createSelector(
  getWishesFilters,
  filters => filters.checked
);



// WEBPACK FOOTER //
// ./src/store/wishes/selectors.js